import axios from 'axios'

export default (date, slider) => {
	axios
		.post(`/schedule/${date}`)
		.then((r) => {
			const {
				data: { schedule },
			} = r
			const findSlider = document.querySelector(`${slider} .js-schedule-carousel`).swiper

			findSlider.removeAllSlides()

			schedule
				.sort((a, b) => a.viewOrder - b.viewOrder)
				.forEach((sh) => {
					const template = document.querySelector('.js-carousel-template').cloneNode(true)

					template.classList.remove('hidden')

					template.querySelector('.item__time').innerHTML = sh.time
					template.querySelector('.item__title').innerHTML = sh.telecast.title

					findSlider.appendSlide(template.innerHTML)
				})
		})
		.catch((err) => console.log(err, 'err'))
}
